document.addEventListener('DOMContentLoaded', function () {
  function initBlock(block) {
    if (block.dataset.cbInit === '1') return;
    block.dataset.cbInit = '1';

    const nextBtn = block.querySelector('.cb-next');
    const prevBtn = block.querySelector('.cb-prev');

    const rawItems = Array.from(block.children).filter(el =>
      el.tagName === 'DIV' &&
      !el.classList.contains('cb-viewport') &&
      !el.classList.contains('cb-track')
    );

    const viewport = document.createElement('div');
    viewport.className = 'cb-viewport';
    const track = document.createElement('div');
    track.className = 'cb-track';

    rawItems.forEach(el => {
      el.removeAttribute('style');
      el.classList.add('cb-item');
      track.appendChild(el);
    });

    viewport.appendChild(track);
    block.insertBefore(viewport, block.firstChild);

    let index = 0;
    let visible = getVisibleCount();
    const itemCount = rawItems.length;

    function getVisibleCount() {
      const val = getComputedStyle(block).getPropertyValue('--cb-visible').trim();
      const n = parseInt(val, 10);
      return Number.isFinite(n) && n > 0 ? n : 3;
    }
    function maxStartIdx() {
      return Math.max(0, itemCount - visible);
    }

    function update() {
      const target = track.children[index];
      const offset = target ? target.offsetLeft : 0;
      track.style.transform = 'translateX(' + (-offset) + 'px)';

      if (prevBtn) prevBtn.style.display = index > 0 ? 'inline-grid' : 'none';

      if (nextBtn) nextBtn.toggleAttribute('disabled', index >= maxStartIdx());
    }

    function recalc() {
      visible = getVisibleCount();
      if (index > maxStartIdx()) index = maxStartIdx();
      update();
    }

    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (index < maxStartIdx()) { index += 1; update(); }
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (index > 0) { index -= 1; update(); }
    });

    const ro = new ResizeObserver(recalc);
    ro.observe(block);
    window.addEventListener('resize', recalc);

    block.addEventListener('cb:refresh', () => setTimeout(recalc, 0));

    update();
  }

  document.querySelectorAll('.collection-blocks').forEach(initBlock);

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.category-buttons button');
    if (!btn) return;

    const wrap = btn.closest('.category-buttons');
    const root = wrap.parentElement;
    const cat  = btn.getAttribute('data-category');

    const allBlocks = Array.from(root.querySelectorAll('.collection-blocks'))
      .filter(b => b.parentElement === root);

    allBlocks.forEach(b => {
      const show = b.getAttribute('data-category') === cat;
      b.style.display = show ? '' : 'none';
      if (show) {
        if (b.dataset.cbInit !== '1') initBlock(b);
        b.dispatchEvent(new Event('cb:refresh'));
      }
    });

    wrap.querySelectorAll('button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});
